export default "__VITE_ASSET__BI30vz9V__"